import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { SaleItemModule } from './sale-item/sale-item.module';

if (environment.production && !environment.prodEnabled) {
  enableProdMode();
  environment.prodEnabled = true;
}

platformBrowserDynamic().bootstrapModule(SaleItemModule)
  .catch((err) => console.error(err));
